var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RadioGroup',{attrs:{"name":"userPasswordOptions","options":_vm.options,"showValidationMessage":false,"value":String(_vm.value)},on:{"input":function($event){return _vm.$emit('input', $event === 'true')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }